<template>
  <div id="app" >
    <div class="wrapper" :class="{isCollapse: $store.state.isCollapse}" v-if="!isLoginPage">
      <!-- 默认侧边导航栏 -->
      <NavBar v-if="!isMapPage"></NavBar>
      <!-- 平台右边区域 -->
      <div class="rightArea"
        :style="{width: $store.state.rightAreaWidth + 'px', marginLeft: $store.state.navBarWidth + 'px', minHeight: (isMapPage ? $store.state.windowHeight : 1200) +'px' }">
        <!-- TopBar -->
        <TopBar></TopBar>
        <!-- 主内容区 -->
        <router-view></router-view>
      </div>
    </div>

    <!-- 登录页面或仪表盘页 -->
    <router-view v-if="isLoginPage"></router-view>
  </div>
</template>

<script>
  import NavBar from '@/components/Layout/NavBar.vue'
  import TopBar from '@/components/Layout/TopBar.vue'
  import MapNavBar from '@/components/Layout/MapNavBar.vue'
  import { localUserInfo } from "../static/js/utility/utility.js"

  export default {
    name: 'App',
    components: {
      NavBar,
      TopBar,
      MapNavBar
    },
    data () {
      return {
        isCollapse: true,
        isLoginPage: false,
        isMapPage: false,
        count:null
      }
    },
    mounted() {
      let vm = this
      // console.log('clientHeight', document.documentElement.clientHeight)
      vm.$store.state.windowHeight = document.documentElement.clientHeight
      // 监听页面宽度变化， 计算右边区域宽度,屏幕高度
      window.onresize = function () {
        return (() => {
          // window.screenWidth = document.body.clientWidth
          // vm.screenWidth = window.screenWidth
          vm.$store.state.rightAreaWidth = document.documentElement.clientWidth - vm.$store.state.navBarWidth
          vm.$store.state.windowHeight = document.documentElement.clientHeight
          // console.log('vm.$store.state.windowHeight', vm.$store.state.windowHeight)
        })()
      }
      // 获取当前页面路径，并判断是否为登录页
      // console.log('是否是登录页面',vm.isLoginPage)
      // console.log('是否是仪表盘页',vm.isMapPage)
      vm.getIsPage()
      // 当本地存储的userInfo存在，赋值给vuex，供页面调用
      if (localUserInfo.getItem()) {
        // console.log('local', localUserInfo.getItem())
        this.$store.state.userInfo = localUserInfo.getItem()
        // console.log(this.$store.state.userInfo)
      }
    },
    computed: {
    },
    methods: {
      // 判断是否是登录页面或仪表盘页
      getIsPage: function () {
        // 登录页
        if (this.$route.path === '/') {
          this.isLoginPage = true 
        } else {
          this.isLoginPage = false 
        }
        // 仪表盘页
        // console.log('tag', this.$route.path.indexOf('/Map'))
        if (this.$route.path.indexOf('/Map') !== -1) {
          this.isMapPage = true
        } else {
          this.isMapPage = false
        }
      }
    },
    watch: {
      // 监听页面跳转，判断是否是登录页
      '$route.path':function (newVal) {
        this.getIsPage()
      }
    }
  }
</script>

<style lang="scss">
$transitionTime: 0.5s;
$minHeight: 1200px;

#app {
  overflow: hidden;
  .wrapper{
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  // 导航栏背景样式
  .wrapper::after {
    height: calc(100% - 1200px);
    content: '';
    border-right: 256px solid #001529;
    position: absolute;
    left: 0;
    top: 1200px;
  }
  .wrapper.isCollapse::after {
    border-right-width: 80px
  }
  .NavBar {
    float: left;
    min-height: $minHeight;
    transition-duration: $transitionTime;
  }
  .rightArea {
    min-height: $minHeight;
    // float: right;
    background-color: #F0F2F5;
    transition-duration: $transitionTime;
    .mainArea {
        min-height: calc(100vh - 64px);
        padding-bottom: 24px;
    }
  }
  .MapNavBar {
    transition-duration: $transitionTime;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue